import { createReducer } from 'service/utility';

import { SET_PEDIDO } from '../actions/appActions';


const initialState = null;

export default createReducer(initialState, {
  [SET_PEDIDO]: (state, { pedido }) => pedido,
});
